var myInitObject = {
lat: null,
long: null,
geoType: null,
}
export default myInitObject;
